import resource from 'resource-axios'
import axios from 'axios'

const _base = 'establishment'
const customActions = {
  update: (params,payload) => axios.patch(`${_base}?id=eq.${params.id}`, payload)
}
export const establishment = resource('/establishment', customActions, axios)
